import {
  GET_ADDRESS_REQUEST,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_FAILURE,
  GET_ERROR_ADDRESS_REQUEST,
  GET_ERROR_ADDRESS_SUCCESS,
  GET_ERROR_ADDRESS_FAILURE,
  GET_WARNING_ADDRESS_REQUEST,
  GET_WARNING_ADDRESS_SUCCESS,
  GET_WARNING_ADDRESS_FAILURE,
  POST_ADDRESS_REQUEST,
  POST_ADDRESS_SUCCESS,
  POST_ADDRESS_FAILURE,
  POST_MULTI_POSTCODES_REQUEST,
  POST_MULTI_POSTCODES_FAILURE,
  POST_EXCEL_CONTACTS_REQUEST,
  POST_EXCEL_CONTACTS_SUCCESS,
  POST_EXCEL_CONTACTS_FAILURE,
  GET_SEND_ADDRESSES_CONFIRM_REQUEST,
  GET_SEND_ADDRESSES_CONFIRM_SUCCESS,
  GET_SEND_ADDRESSES_CONFIRM_FAILURE,
  GET_ORDERED_FOLLOW_CALL_CONFIRM_REQUEST,
  GET_ORDERED_FOLLOW_CALL_CONFIRM_SUCCESS,
  GET_ORDERED_FOLLOW_CALL_CONFIRM_FAILURE,
  DELETE_ADDRESS_MULTI_REQUEST,
  DELETE_ADDRESS_MULTI_SUCCESS,
  DELETE_ADDRESS_MULTI_FAILURE,
  PUT_ADDRESS_TAGS_MULTI_REQUEST,
  PUT_ADDRESS_TAGS_MULTI_SUCCESS,
  PUT_ADDRESS_TAGS_MULTI_FAILURE,
  DELETE_ERROR_ADDRESS_MULTI_REQUEST,
  DELETE_ERROR_ADDRESS_MULTI_SUCCESS,
  DELETE_ERROR_ADDRESS_MULTI_FAILURE,
  DELETE_WARNING_ADDRESS_MULTI_REQUEST,
  DELETE_WARNING_ADDRESS_MULTI_SUCCESS,
  DELETE_WARNING_ADDRESS_MULTI_FAILURE,
  POST_ERROR_ADDRESS_REQUEST,
  POST_ERROR_ADDRESS_SUCCESS,
  POST_ERROR_ADDRESS_FAILURE,
  POST_WARNING_ADDRESSES_REQUEST,
  POST_WARNING_ADDRESSES_SUCCESS,
  POST_WARNING_ADDRESSES_FAILURE,
  POST_WARNING_ADDRESSES_RESTORE_REQUEST,
  POST_WARNING_ADDRESSES_RESTORE_SUCCESS,
  POST_WARNING_ADDRESSES_RESTORE_FAILURE,
  PATCH_CONTACTS_REQUEST,
  PATCH_CONTACTS_SUCCESS,
  PATCH_CONTACTS_FAILURE,
  CLEAR_ADDRESS_DATA,
  GET_ADDRESS_TAGS_REQUEST,
  GET_ADDRESS_TAGS_SUCCESS,
  GET_ADDRESS_TAGS_FAILURE,
  GET_ADDRESS_SUGGEST_CORP_REQUEST,
  GET_ADDRESS_SUGGEST_CORP_SUCCESS,
  GET_ADDRESS_SUGGEST_CORP_FAILURE,
  GET_FAILED_LINK_ADDRESS_SUCCESS,
  PUT_ADDRESS_LINK_CORPORATION_REQUEST,
  PUT_ADDRESS_LINK_CORPORATION_SUCCESS,
  PUT_ADDRESS_LINK_CORPORATION_FAILURE,
  POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_REQUEST,
  POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_SUCCESS,
  POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_FAILURE,
  POST_WARNING_ADDRESSES_OVERWRITE_REQUEST,
  POST_WARNING_ADDRESSES_OVERWRITE_SUCCESS,
  POST_WARNING_ADDRESSES_OVERWRITE_FAILURE,
  GET_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
  GET_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  GET_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  GET_WARNING_ADDRESS_TAGS_REQUEST,
  GET_WARNING_ADDRESS_TAGS_SUCCESS,
  GET_WARNING_ADDRESS_TAGS_FAILURE,
  GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
  GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  GET_ERROR_ADDRESS_TAGS_REQUEST,
  GET_ERROR_ADDRESS_TAGS_SUCCESS,
  GET_ERROR_ADDRESS_TAGS_FAILURE,
  GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST,
  GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS,
  GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE,
  GET_NG_SENDINGS_REQUEST,
  GET_NG_SENDINGS_SUCCESS,
  GET_NG_SENDINGS_FAILURE,
  POST_NG_SENDINGS_REQUEST,
  POST_NG_SENDINGS_SUCCESS,
  POST_NG_SENDINGS_FAILURE,
  POST_NG_SENDINGS_EXCEL_REQUEST,
  POST_NG_SENDINGS_EXCEL_SUCCESS,
  POST_NG_SENDINGS_EXCEL_FAILURE,
  DELETE_NG_SENDINGS_REQUEST,
  DELETE_NG_SENDINGS_SUCCESS,
  DELETE_NG_SENDINGS_FAILURE,
  DELETE_NG_SENDINGS_BY_ID_REQUEST,
  DELETE_NG_SENDINGS_BY_ID_SUCCESS,
  DELETE_NG_SENDINGS_BY_ID_FAILURE,
  PUT_NG_SENDINGS_REQUEST,
  PUT_NG_SENDINGS_SUCCESS,
  PUT_NG_SENDINGS_FAILURE,
  POST_ADDRESSES_MOVE_NG_SENDINGS_REQUEST,
  POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS,
  POST_ADDRESSES_MOVE_NG_SENDINGS_FAILURE,
  POST_ADDRESSES_RESTORE_NG_SENDINGS_REQUEST,
  POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS,
  POST_ADDRESSES_RESTORE_NG_SENDINGS_FAILURE,
  GET_WARNING_ADDRESS_SUGGEST_CORP_REQUEST,
  GET_WARNING_ADDRESS_SUGGEST_CORP_SUCCESS,
  GET_WARNING_ADDRESS_SUGGEST_CORP_FAILURE,
  GET_ERROR_ADDRESS_SUGGEST_CORP_REQUEST,
  GET_ERROR_ADDRESS_SUGGEST_CORP_SUCCESS,
  GET_ERROR_ADDRESS_SUGGEST_CORP_FAILURE,
  PUT_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
  PUT_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
  PUT_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
  PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
  PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_REQUEST,
  PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_SUCCESS,
  PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_FAILURE,
  PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST,
  PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS,
  PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE,
  POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_REQUEST,
  POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_SUCCESS,
  POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_FAILURE,
  GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_SUCCESS,
  GET_ADDRESS_TOTALS_SUCCESS,
  POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_REQUEST,
  POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_SUCCESS,
  POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_FAILURE,
  POST_WARNING_ADDRESSES_OVERWRITEMULTI_REQUEST,
  POST_WARNING_ADDRESSES_OVERWRITEMULTI_SUCCESS,
  POST_WARNING_ADDRESSES_OVERWRITEMULTI_FAILURE,
  POST_WARNING_ADDRESSES_MULTI_REQUEST,
  POST_WARNING_ADDRESSES_MULTI_SUCCESS,
  POST_WARNING_ADDRESSES_MULTI_FAILURE,
  GET_EXECUTIVE_LIST_COUNT_SUCCESS,
  POST_ADDRESS_LIST_SALESFORCE_SYNC_REQUEST,
  POST_ADDRESS_LIST_SALESFORCE_SYNC_SUCCESS,
  POST_ADDRESS_LIST_SALESFORCE_SYNC_FAILURE,
  STORE_FILTER_VALUE,
  LOG_OUT_SUCCESS,
} from '../../constants/ActionTypes'

import { AddressBookTab } from '../../constants/ComponentTypes'
import * as errMessages from '../../constants/ErrorMessages';
import * as messages from '../../constants/Messages';
import { formatErrorMessage } from '../../utils/utils';
import { isExpiredAccessError } from "../../utils/salesforceUtils";
const { OrderedMap } = require('immutable')

const initialState = {
  addressItems: OrderedMap({}),
  errorItems: OrderedMap({}),
  warningItems: OrderedMap({}),
  ngList: OrderedMap({}),
  tags: [],
  selectedAddressTags: [],
  importHistories: [],
  warningAddressTags: [],
  warningImportHistories: [],
  errorAddressTags: [],
  errorImportHistories: [],
  isLoading: false,
  isLoadingErrorAddress: false,
  isLoadingWarningAddress: false,
  isLoadingNgList: false,
  isLoadingSidebar: 0,
  isLoadingSelectedAddressTags: false,
  isFiltering: false,
  isSaving: false,
  isUploadingExcel: false,
  isUpdatingTags: false,
  isDeleting: false,
  isPutting: false,
  shortMessage: '',
  successMessage: '',
  errorMessage: '',
  hasError: false,
  undoable: false,
  prevItem: null,
  warningToAddressItem: null,
  pageInfo_all: null,
  pageInfo_error: null,
  pageInfo_warning: null,
  pageInfo_ngList: null,
  totalAddresses: 0,
  totalErrorAddresses: 0,
  totalWarningAddresses: 0,
  totalNgList: 0,
  overwrite: false,
  corporations: OrderedMap({}),
  isLoadingCorp: false,
  failedLinkCorporationCount: 0,
  isPostWarningAddressWithExecutivePerson: false,
  isOverwritingWarningAddress: false,
  isOverwritingWarningAddresses: false,
  error: null,
  execListCount: null,
  isDeletingAddressTags: false,
  isUpdatingAddressTags: false,
  isVerifying: false,
  isUpdatingDifferences: false,
  addressCorporationDifferencesCount: {
    diff_company_name_count: 0,
    diff_address_count: 0,
    close_count: 0,
  },
  filterValue: null,
  isLoadingCheck: false,
  hasLetterOrderHistoryNames: [],
  duplicateNames: [],
  orderedFollowCallNames: [],
  isMixedAddresses: false,
  selectAddress: null,
  isImporting: false,
  syncCount: 0,
  lastUpdate: null,
};

export default (state = initialState, action) => {
  let message, tags, addressItems,
  errorItems, warningItems, ngList, error, item,
  pageInfo_all, pageInfo_error, pageInfo_warning, pageInfo_ngList,
  id, hasLetterOrderHistoryNames = [], duplicateNames = [], orderedFollowCallNames = [];

  state = {
    ...state,
    hasError: false,
    shortMessage: '',
    successMessage: '',
    errorMessage: '',
    error: null,
    undoable: false,
  }

  switch (action.type) {
    case GET_ADDRESS_REQUEST:
      return {
        ...state,
        isLoading: true,
        overwrite: action.payload.overwrite,
      }
    case GET_ADDRESS_SUCCESS:
      addressItems = action.payload.overwrite ? OrderedMap({}): state.addressItems;

      action.payload.contacts.forEach(item => {
        addressItems = addressItems.set(item.id, item);
      })

      return {
        ...state,
        isLoading: false,
        pageInfo_all: {...action.payload.pageInfo},
        addressItems: addressItems,
        overwrite: false,
      }
    case GET_ADDRESS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);

      return {
        ...state,
        errorMessage: message,
        hasError: true,
        isLoading: false,
        overwrite: false,
      }
    case GET_ERROR_ADDRESS_REQUEST:
      return {
        ...state,
        isLoadingErrorAddress: true,
        overwrite: action.payload.overwrite,
      }
    case GET_ERROR_ADDRESS_SUCCESS:
      errorItems = action.payload.overwrite ? OrderedMap({}): state.errorItems;
      action.payload.contacts.forEach(item => {
        errorItems = errorItems.set(item.id, item);
      })
      return {
        ...state,
        isLoadingErrorAddress: false,
        errorItems: errorItems,
        pageInfo_error: action.payload.pageInfo,
        overwrite: false,
      }
    case GET_ERROR_ADDRESS_FAILURE:
      return {
        ...state,
        isLoadingErrorAddress: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
        overwrite: false,
      }
    case GET_WARNING_ADDRESS_REQUEST:
      return {
        ...state,
        isLoadingWarningAddress: true,
        overwrite: action.payload.overwrite,
      }
    case GET_WARNING_ADDRESS_SUCCESS:
      warningItems = action.payload.overwrite ? OrderedMap({}): state.warningItems;
      action.payload.contacts.forEach(item => {
        warningItems = warningItems.set(item.id, item)
      })
      return {
        ...state,
        isLoadingWarningAddress: false,
        warningItems: warningItems,
        pageInfo_warning: action.payload.pageInfo,
        overwrite: false,
      }
    case GET_WARNING_ADDRESS_FAILURE:
      return {
        ...state,
        isLoadingWarningAddress: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
        overwrite: false,
      }

    case POST_ADDRESS_REQUEST:
    case POST_ERROR_ADDRESS_REQUEST:
    case POST_WARNING_ADDRESSES_REQUEST:
    case POST_MULTI_POSTCODES_REQUEST:
    case PATCH_CONTACTS_REQUEST:
      return {
        ...state,
        isSaving: true,
      }
    case POST_ADDRESS_SUCCESS:
      addressItems = state.addressItems;

      tags = new Set(state.tags);
      pageInfo_all={...state.pageInfo_all};

      action.payload.items.addresses.forEach(item => {
        let id = item.id;
        addressItems = addressItems.set(id, item);
        pageInfo_all.total++;
        if (item && item.tags && item.tags.length>0) {
          item.tags.forEach(tag => tags.add(tag));
        }
      })

      return {
        ...state,
        addressItems: addressItems,
        shortMessage: messages.POST_SUCCESS,
        isSaving: false,
        tags: Array.from(tags),
        pageInfo_all: pageInfo_all,
      }
    case POST_ERROR_ADDRESS_SUCCESS:
      tags = new Set(state.tags);

      item = action.payload.item.addresses[0];

      errorItems = state.errorItems.delete(action.payload.errorId);
      addressItems = state.addressItems.set(item.id, item);

      if (item && item.tags && item.tags.length>0) {
        item.tags.forEach(tag => tags.add(tag));
      }

      return {
        ...state,
        addressItems: addressItems,
        pageInfo_all: state.pageInfo_all ? {...state.pageInfo_all, total: state.pageInfo_all.total+1} : {},
        pageInfo_error: state.pageInfo_error ? {...state.pageInfo_error, total: state.pageInfo_error.total-1} : {},
        errorItems: errorItems,
        shortMessage: messages.POST_SUCCESS,
        isSaving: false,
        tags: Array.from(tags),
      }
    case POST_WARNING_ADDRESSES_SUCCESS: {
      tags = new Set(state.tags);

      item = action.payload.item.addresses[0];

      let prevItem = state.warningItems.get(action.payload.warningId);
      warningItems = state.warningItems.delete(action.payload.warningId);

      addressItems = state.addressItems.set(item.id, item);

      if (item && item.tags && item.tags.length > 0) {
        item.tags.forEach(tag => tags.add(tag));
      }

      return {
        ...state,
        addressItems: addressItems,
        pageInfo_warning: state.pageInfo_warning ? {...state.pageInfo_warning, total: state.pageInfo_warning.total-1}: {},
        warningItems: warningItems,
        shortMessage: messages.POST_SUCCESS,
        undoable: true,
        isSaving: false,
        tags: Array.from(tags),
        prevItem: prevItem,
        warningToAddressItem: item,
      }
    }
    case POST_ADDRESS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE);
      errorItems = state.errorItems;
      warningItems = state.warningItems;
      pageInfo_error = state.pageInfo_error;
      pageInfo_warning = state.pageInfo_warning;

      if(action.payload.error
        && action.payload.error.data
        && action.payload.error.data.message) {
        if(typeof action.payload.error.data.message === "object") {
          return {
            ...state,
            hasError: true,
            error: action.payload.error.data.message,
          }
        } else if (typeof action.payload.error.data.message === "string") {
          message = action.payload.error.data.message;
          if(action.payload.error.data.data) {
            let { warning_addresses, error_addresses } = action.payload.error.data.data;

            error_addresses.forEach(address => {
              errorItems = errorItems.set(address.id, address);
            })

            warning_addresses.forEach(address => {
              warningItems = warningItems.set(address.id, address);
            })
          }
        }
      }

      return {
        ...state,
        hasError: true,
        errorMessage: message,
        isSaving: false,
        errorItems: errorItems,
        warningItems: warningItems,
        pageInfo_error: pageInfo_error,
        pageInfo_warning: pageInfo_warning,
      }
    case POST_MULTI_POSTCODES_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE);

      if (action.payload.error && action.payload.error.data && action.payload.error.data.message) {
        if (typeof action.payload.error.data.message === "object") {
          return {
            ...state,
            hasError: true,
            error: action.payload.error.data.message,
          }
        } else if (typeof action.payload.error.data.message === "string") {
          message = message + action.payload.error.data.message;
        }
      }

      return {
        ...state,
        hasError: true,
        isSaving: false,
        errorMessage: message,
      }
    case POST_ERROR_ADDRESS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE);
      errorItems = state.errorItems;
      warningItems = state.warningItems;
      pageInfo_error={...state.pageInfo_error}

      if(action.payload.error
        && action.payload.error.data
        && action.payload.error.data.message) {
        if(typeof action.payload.error.data.message === "object") {
          return {
            ...state,
            hasError: true,
            error: action.payload.error.data.message,
          }
        } else if (typeof action.payload.error.data.message === "string") {
          message = action.payload.error.data.message;
          if(action.payload.error.data.data) {
            let {warning_addresses} = action.payload.error.data.data;
            if(warning_addresses.length > 0) {
              pageInfo_error.total--;
              warningItems = warningItems.set(warning_addresses[0].id, warning_addresses[0]);
              errorItems = errorItems.delete(action.payload.errorId);
            }
          }
        }
      }

      return {
        ...state,
        hasError: true,
        errorMessage: message,
        isSaving: false,
        errorItems: errorItems,
        warningItems: warningItems,
        pageInfo_error: pageInfo_error,
      }
    case POST_WARNING_ADDRESSES_FAILURE:
      message = '';
      errorItems = state.errorItems;
      warningItems = state.warningItems;
      pageInfo_warning={...state.pageInfo_warning}

      if(action.payload.error
        && action.payload.error.data
        && action.payload.error.data.message) {
        if(typeof action.payload.error.data.message === "object") {
          return {
            ...state,
            hasError: true,
            error: action.payload.error.data.message,
          }
        } else if (typeof action.payload.error.data.message === "string") {
          if(action.payload.error.data.data) {
            let { error_addresses, warning_addresses } = action.payload.error.data.data;

            if (error_addresses.length > 0) {
              message = action.payload.error.data.message;
              if (pageInfo_warning && pageInfo_warning.total) {
                pageInfo_warning.total--;
              }
              errorItems = errorItems.set(error_addresses[0].id, error_addresses[0]);
              warningItems = warningItems.delete(action.payload.warningId);
            } else if (warning_addresses.length > 0) {
              warningItems = warningItems.set(warning_addresses[0].id, warning_addresses[0]);
            }
          }
        }
      }

      return {
        ...state,
        hasError: true,
        errorMessage: message + action.payload.error.data.message,
        isSaving: false,
        errorItems: errorItems,
        warningItems: warningItems,
        pageInfo_warning: pageInfo_warning,
      }
    case POST_EXCEL_CONTACTS_REQUEST:
      return {
        ...state,
        isUploadingExcel: true,
        isSaving: true,
      }
    case POST_EXCEL_CONTACTS_SUCCESS: {
      pageInfo_all={...state.pageInfo_all};

      let {addresses, error_addresses, warning_addresses} = action.payload.items;

      pageInfo_all.total += addresses.length;

      if(error_addresses.length > 0 || warning_addresses.length > 0) {
        message = `${error_addresses.length + warning_addresses.length + addresses.length}件中${addresses.length}件がメインボックス、${warning_addresses.length}件が警告ボックス、${error_addresses.length}件がエラーボックスに登録されました。`;
      } else {
        message =`${addresses.length}件のアイテムを登録しました。`;
      }

      return {
        ...state,
        successMessage: message,
        isUploadingExcel: false,
        isSaving: false,
        pageInfo_all: pageInfo_all,
      }
    }
    case POST_EXCEL_CONTACTS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE);
      error = state.error;

      if(action.payload.error && action.payload.error.data && action.payload.error.data.message) {
        if(typeof action.payload.error.data.message === "object") {
          error = action.payload.error.data.message;
          message = formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE);
        } else if (typeof action.payload.error.data.message === "string") {
          message = action.payload.error.data.message;
        }
      }

      return {
        ...state,
        hasError: true,
        errorMessage: message,
        error: error,
        isUploadingExcel: false,
        isSaving: false,
      }
    case PUT_ADDRESS_TAGS_MULTI_REQUEST:
      return {
        ...state,
        isUpdatingTags: true,
      }
    case PUT_ADDRESS_TAGS_MULTI_SUCCESS:
      // we are not manually updating the tag property of each object
      // because tags can only be viewed on addressDetail
      // where GET will be called again
      // here we just update the tags here

      return {
        ...state,
        isUpdatingTags: false,
        tags: Array.from(new Set(state.tags.concat(action.payload.tags))),
        shortMessage: messages.ADD_TAG_SUCCESS,
      }
    case PUT_ADDRESS_TAGS_MULTI_FAILURE: {
      message = formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE);
      let errMsgArray = [];
      if(typeof action.payload.error.data.message === 'object') {
        Object.values(action.payload.error.data.message).forEach(messageArray => {
          errMsgArray = errMsgArray.concat(messageArray);
        }
      )}

      return {
        ...state,
        isUpdatingTags: false,
        hasError: true,
        errorMessage: message+" "+errMsgArray.join(" "),
      }
    }
    case GET_SEND_ADDRESSES_CONFIRM_REQUEST:
      return {
        ...state,
        isLoadingCheck: true,
        isMixedAddresses: false,
      }
    case GET_SEND_ADDRESSES_CONFIRM_SUCCESS:
      hasLetterOrderHistoryNames = Array.from(action.payload.hasLetterOrderHistoryNames);
      duplicateNames = Array.from(action.payload.duplicateNames);

      return {
        ...state,
        isLoadingCheck: false,
        hasLetterOrderHistoryNames: hasLetterOrderHistoryNames,
        duplicateNames: duplicateNames,
        selectAddress: action.payload.selectAddress,
      }
    case GET_SEND_ADDRESSES_CONFIRM_FAILURE:
      // 会社宛と会社個人宛の注文があった場合
      if (action.payload.error.data.message === "会社宛と個人宛の宛先が混在しています。") {
        return {
          ...state,
          isLoadingCheck: false,
          isMixedAddresses: true,
        }
      }
      return {
        ...state,
        isLoadingCheck: false,
        errorMessage: action.payload.error.data.message ? action.payload.error.data.message : errMessages.ERR_ORDER_FAILURE
      }
    case GET_ORDERED_FOLLOW_CALL_CONFIRM_REQUEST:
      return {
        ...state,
        isLoadingCheck: true,
        isMixedAddresses: false,
      }
    case GET_ORDERED_FOLLOW_CALL_CONFIRM_SUCCESS:
      orderedFollowCallNames = Array.from(action.payload.names);
      return {
        ...state,
        isLoadingCheck: false,
        orderedFollowCallNames: orderedFollowCallNames,
        selectAddress: action.payload.selectAddress,
      }
    case GET_ORDERED_FOLLOW_CALL_CONFIRM_FAILURE:
      // 会社宛と会社個人宛の注文があった場合
      if (action.payload.error.data.message === "会社宛と個人宛の宛先が混在しています。") {
        return {
          ...state,
          isLoadingCheck: false,
          isMixedAddresses: true,
        }
      }
      return {
        ...state,
        isLoadingCheck: false,
        errorMessage: action.payload.error.data.message ? action.payload.error.data.message : errMessages.ERR_ORDER_FAILURE
      }
    case DELETE_ADDRESS_MULTI_REQUEST:
    case DELETE_ERROR_ADDRESS_MULTI_REQUEST:
    case DELETE_WARNING_ADDRESS_MULTI_REQUEST:
      return {
        ...state,
        isDeleting: true,
      }
    case DELETE_ADDRESS_MULTI_SUCCESS:
      //actionsで、削除成功後、アドレスデータをクリアして、
      //GETで改めて叩いて最新のaddressを読み込むので。
      //こちらでデータクリアする必要はありません
      message = (action.payload.message === "" ? "Salesforceから登録したアドレス以外を削除しました。" : "Salesforceから登録したアドレス以外で、" + action.payload.message );
      return {
        ...state,
        successMessage: message,
        isDeleting: false,
      }

    case DELETE_ERROR_ADDRESS_MULTI_SUCCESS:
      //actionsで、削除成功後、アドレスデータをクリアして、
      //GETで改めて叩いて最新のerror_addressを読み込むので。
      //こちらでデータクリアする必要はありません
      return {
        ...state,
        shortMessage: action.payload.message !== "" ? action.payload.message : messages.DELETE_SUCCESS,
        isDeleting: false,
      }
    case DELETE_WARNING_ADDRESS_MULTI_SUCCESS:
      //actionsで、削除成功後、アドレスデータをクリアして、
      //GETで改めて叩いて最新のwarning_addressを読み込むので。
      //こちらでデータクリアする必要はありません
      return {
        ...state,
        shortMessage: action.payload.message !== "" ? action.payload.message : messages.DELETE_SUCCESS,
        isDeleting: false,
      }
    case DELETE_ADDRESS_MULTI_FAILURE:
    case DELETE_ERROR_ADDRESS_MULTI_FAILURE:
    case DELETE_WARNING_ADDRESS_MULTI_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_REMOVE_FAILURE);

      return {
        ...state,
        errorMessage: message,
        isDeleting: false,
      }
    case PATCH_CONTACTS_SUCCESS:
      addressItems = state.addressItems;
      id = action.payload.edited.id;

      if(addressItems.has(id)) {
        addressItems = addressItems.set(id, action.payload.edited);
      }

      return {
        ...state,
        addressItems: addressItems,
        shortMessage: messages.SAVE_SUCCESS,
        isSaving: false,
      }
    case PATCH_CONTACTS_FAILURE:
      error = state.error;

      if (action.payload.error.data && action.payload.error.data.message && typeof action.payload.error.data.message === 'string') {
        error = action.payload.error.data.message;
      }

      return {
        ...state,
        isSaving: false,
        error: error,
        errorMessage: error ? '': errMessages.ERR_EDIT_FAILURE,
      }
    case POST_WARNING_ADDRESSES_RESTORE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case POST_WARNING_ADDRESSES_RESTORE_SUCCESS:
      return {
        ...state,
        shortMessage: '元に戻しました。',
        prevItem: null,
        warningToAddressItem: null,
        warningItems: state.warningItems.set(state.prevItem.id, state.prevItem),
        addressItems: state.addressItems.delete(state.warningToAddressItem.id),
        pageInfo_warning: {...state.pageInfo_warning, total: state.pageInfo_warning.total+1},
        isSaving: false,
      }
    case POST_WARNING_ADDRESSES_RESTORE_FAILURE:
      return {
        ...state,
        isSaving: false,
        errorMessage: '元に戻す処理に失敗しました。お手数ですが、アドレスを直接削除してください。',
      }
    case CLEAR_ADDRESS_DATA:
      if(action.payload.tab === AddressBookTab.ALL) {
        return {
          ...state,
          addressItems: OrderedMap({}),
          pageInfo_all: null,
        }
      } else if (action.payload.tab === AddressBookTab.WARNING) {
        return {
          ...state,
          warningItems: OrderedMap({}),
          pageInfo_warning: null,
        }
      } else if (action.payload.tab === AddressBookTab.ERROR) {
        return {
          ...state,
          errorItems: OrderedMap({}),
          pageInfo_error: null,
        }
      } else {
        return {
          ...state,
          addressItems: OrderedMap({}),
          warningItems: OrderedMap({}),
          errorItems: OrderedMap({}),
          pageInfo_all: null,
          pageInfo_warning: null,
          pageInfo_error: null,
        }
      }

    case GET_ADDRESS_TAGS_REQUEST:
      if(action.payload.isAllTags) {
        return {
          ...state,
          isLoadingSidebar: state.isLoadingSidebar-1,
        }
      } else {
        return {
          ...state,
          selectedAddressTags: action.payload.overwrite ? []: state.selectedAddressTags,
          isLoadingSelectedAddressTags: true,
        }
      }
    case GET_ADDRESS_TAGS_SUCCESS:
      tags = Array.from(action.payload.tags);
      if(action.payload.isAllTags) {
        return {
          ...state,
          tags: tags,
          isLoadingSidebar: state.isLoadingSidebar+1,
        }
      } else {
        return {
          ...state,
          selectedAddressTags: tags,
          isLoadingSelectedAddressTags: false,
        }
      }
    case GET_ADDRESS_TAGS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);
      if(action.payload.isAllTags) {
        return {
          ...state,
          errorMessage: message,
          isLoadingSidebar: state.isLoadingSidebar+1,
        }
      } else {
        return {
          ...state,
          errorMessage: message,
          isLoadingSelectedAddressTags: false,
        }
      }
    case GET_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST:
      return {
        ...state,
        isLoadingSidebar: state.isLoadingSidebar-1,
      }
    case GET_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS:
      return {
        ...state,
        importHistories: Array.from(action.payload.tags),
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);

      return {
        ...state,
        errorMessage: message,
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_WARNING_ADDRESS_TAGS_REQUEST:
      return {
        ...state,
        isLoadingSidebar: state.isLoadingSidebar-1,
      }
    case GET_WARNING_ADDRESS_TAGS_SUCCESS:
      tags = Array.from(action.payload.tags);
      return {
        ...state,
        warningAddressTags: tags,
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_WARNING_ADDRESS_TAGS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);
      return {
        ...state,
        errorMessage: message,
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST:
      return {
        ...state,
        isLoadingSidebar: state.isLoadingSidebar-1,
      }
    case GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS:
      return {
        ...state,
        warningImportHistories: Array.from(action.payload.tags),
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
  case GET_WARNING_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE:
    message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);

    return {
      ...state,
      errorMessage: message,
      isLoadingSidebar: state.isLoadingSidebar+1,
    }
    case GET_ERROR_ADDRESS_TAGS_REQUEST:
      return {
        ...state,
        isLoadingSidebar: state.isLoadingSidebar-1,
      }
    case GET_ERROR_ADDRESS_TAGS_SUCCESS:
      tags = Array.from(action.payload.tags);
      return {
        ...state,
        errorAddressTags: tags,
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_ERROR_ADDRESS_TAGS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);
      return {
        ...state,
        errorMessage: message,
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_REQUEST:
      return {
        ...state,
        isLoadingSidebar: state.isLoadingSidebar-1,
      }
    case GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_SUCCESS:
      return {
        ...state,
        errorImportHistories: Array.from(action.payload.tags),
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_ERROR_ADDRESS_IMPORT_HISTORY_TAGS_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);

      return {
        ...state,
        errorMessage: message,
        isLoadingSidebar: state.isLoadingSidebar+1,
      }
    case GET_ADDRESS_SUGGEST_CORP_REQUEST:
    case GET_WARNING_ADDRESS_SUGGEST_CORP_REQUEST:
    case GET_ERROR_ADDRESS_SUGGEST_CORP_REQUEST:
      return {
        ...state,
        isLoadingCorp: true,
        corporations: OrderedMap({}),
      }
    case GET_ADDRESS_SUGGEST_CORP_SUCCESS:
    case GET_WARNING_ADDRESS_SUGGEST_CORP_SUCCESS:
    case GET_ERROR_ADDRESS_SUGGEST_CORP_SUCCESS: {
      let corporations = OrderedMap({});
      action.payload.corporations.forEach(item => {
        corporations = corporations.set(item.id, item);
      })
      return {
        ...state,
        isLoadingCorp: false,
        corporations: corporations,
      }
    }
    case GET_ADDRESS_SUGGEST_CORP_FAILURE:
    case GET_WARNING_ADDRESS_SUGGEST_CORP_FAILURE:
    case GET_ERROR_ADDRESS_SUGGEST_CORP_FAILURE:
      message = formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE);

      return {
        ...state,
        isLoadingCorp: false,
        errorMessage: message,
      }
    case GET_FAILED_LINK_ADDRESS_SUCCESS:
      return {
        ...state,
        failedLinkCorporationCount: action.payload.pageInfo.total,
      }
    case PUT_ADDRESS_LINK_CORPORATION_REQUEST:
      return {
        ...state,
        isPutting: true,
      }
    case PUT_ADDRESS_LINK_CORPORATION_SUCCESS:
      return {
        ...state,
        isPutting: false,
        successMessage: '法人番号の紐付けを開始しました。紐付け完了まで数秒〜数分かかります。画面遷移しても問題ありません。',
      }
    case PUT_ADDRESS_LINK_CORPORATION_FAILURE:
      return {
        ...state,
        isPutting: false,
        errorMessage: action.payload.error.message !== "" ? action.payload.error.message :errMessages.ERR_EDIT_FAILURE,
      }
    case POST_WARNING_ADDRESSES_OVERWRITE_REQUEST:
      return {
        ...state,
        isOverwritingWarningAddress: true,
      }
    case POST_WARNING_ADDRESSES_OVERWRITE_SUCCESS:
      return {
        ...state,
        isOverwritingWarningAddress: false,
        shortMessage: messages.POST_SUCCESS,
      }
    case POST_WARNING_ADDRESSES_OVERWRITE_FAILURE:
      return {
        ...state,
        isOverwritingWarningAddress: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE),
      }
    case POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_REQUEST:
      return {
        ...state,
        isPostWarningAddressWithExecutivePerson: true,
      }
    case POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_SUCCESS:
      return {
        ...state,
        isPostWarningAddressWithExecutivePerson: false,
        shortMessage: messages.POST_SUCCESS,
      }
    case POST_WARNING_ADDRESSES_WITH_EXECUTIVE_PERSON_FAILURE:
      return {
        ...state,
        isPostWarningAddressWithExecutivePerson: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE),
      }
    case GET_ADDRESS_TOTALS_SUCCESS:
      return {
        ...state,
        totalAddresses: action.payload.totals.totalAddresses,
        totalWarningAddresses: action.payload.totals.totalWarningAddresses,
        totalErrorAddresses: action.payload.totals.totalErrorAddresses,
        totalNgList: action.payload.totals.totalNgList,
      }
    case GET_NG_SENDINGS_REQUEST:
      return {
        ...state,
        isLoadingNgList: true,
        overwrite: action.payload.overwrite
      }
    case GET_NG_SENDINGS_SUCCESS:
      ngList = action.payload.overwrite ? OrderedMap({}): state.ngList;
      action.payload.list.forEach(item => {
        ngList = ngList.set(item.id, item)
      })

      return {
        ...state,
        isLoadingNgList: false,
        ngList: ngList,
        pageInfo_ngList: action.payload.pageInfo,
        overwrite: false,
      }
    case GET_NG_SENDINGS_FAILURE:
      return {
        ...state,
        isLoadingNgList: false,
        overwrite: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    case POST_NG_SENDINGS_REQUEST:
      return {
        ...state,
        isSaving: true,
      }
    case POST_NG_SENDINGS_SUCCESS:
      ngList = state.ngList;
      pageInfo_ngList = {...pageInfo_ngList}

      action.payload.ng_sendings.forEach(item => {
        ngList.set(item.id, item);
      })
      pageInfo_ngList.total = pageInfo_ngList.total + action.payload.ng_sendings.length;

      return {
        ...state,
        isSaving: false,
        shortMessage: messages.SAVE_SUCCESS,
        pageInfo_ngList: pageInfo_ngList,
        ngList: ngList,
      }
    case POST_NG_SENDINGS_FAILURE:
      message = errMessages.ERR_REGIST_FAILURE;
      error = state.error;

      if (action.payload.error) {
        if (action.payload.error.message) {
          message = action.payload.error.message;
        }

        if (action.payload.error.data &&
          Array.isArray(action.payload.error.data.errors) &&
          action.payload.error.data.errors.length === 1) {
          let err = action.payload.error.data.errors[0];

          if (typeof err === 'string') {
            message = message + err;
          } else if (typeof err === 'object'){
            error = {...err};
          }
        }
      }
      return {
        ...state,
        isSaving: false,
        error: error ? error : message,
      }
    case PUT_NG_SENDINGS_REQUEST:
      return {
        ...state,
        isSaving: true,
      }
    case PUT_NG_SENDINGS_SUCCESS:
      ngList = state.ngList;
      ngList.set(action.payload.item.id, action.payload.item);

      return {
        ...state,
        isSaving: false,
        shortMessage: messages.SAVE_SUCCESS,
        ngList: ngList,
      }
    case PUT_NG_SENDINGS_FAILURE:
      error = state.error;

      if (action.payload.error) {
        if (typeof action.payload.error.message === "string" ) {
          error = action.payload.error.message;
        } else if (typeof action.payload.error.message === "object") {
          error = {...action.payload.error.message };
        }
      }

      return {
        ...state,
        isSaving: false,
        error: error,
      }
    case POST_NG_SENDINGS_EXCEL_REQUEST:
      return {
        ...state,
        isSaving: true,
        isUploadingExcel: true,
      }
    case POST_NG_SENDINGS_EXCEL_SUCCESS:
      message = messages.SAVE_SUCCESS;
      if(action.payload.errors !== null) {
        let numErrors = Array.isArray(action.payload.errors) ? action.payload.errors.length : Object.keys(action.payload.errors).length;
        message = `${numErrors + action.payload.ng_sendings.length}件中${action.payload.ng_sendings.length}件が登録されました。`;

        return {
          ...state,
          isSaving: false,
          isUploadingExcel: false,
          successMessage: message,
        }
      } else {
        return {
          ...state,
          isSaving: false,
          isUploadingExcel: false,
          shortMessage: message,
        }
      }
    case POST_NG_SENDINGS_EXCEL_FAILURE:
      message = errMessages.ERR_REGIST_FAILURE;
      error = state.error;

      if (action.payload.error && action.payload.error.message && typeof action.payload.error.message === "string") {
        message = action.payload.error.message;
      }
      return {
        ...state,
        isSaving: false,
        isUploadingExcel: false,
        errorMessage: message,
      }
    case DELETE_NG_SENDINGS_REQUEST:
    case DELETE_NG_SENDINGS_BY_ID_REQUEST:
      return {
        ...state,
        isDeleting: true,
      }
    case DELETE_NG_SENDINGS_BY_ID_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        shortMessage: messages.DELETE_NG_SENDINGS_SUCCESS,
      }
    case DELETE_NG_SENDINGS_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        shortMessage: action.payload.message !=="" ? action.payload.message : messages.DELETE_NG_SENDINGS_SUCCESS,
      }
    case DELETE_NG_SENDINGS_FAILURE:
    case DELETE_NG_SENDINGS_BY_ID_FAILURE:
      return {
        ...state,
        isDeleting: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_REMOVE_FAILURE),
      }
    case POST_ADDRESSES_RESTORE_NG_SENDINGS_REQUEST:
      return {
        ...state,
        isPutting: true,
      }
    case POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS:
      return {
        ...state,
        isPutting: false,
        prevItem: null,
        shortMessage: messages.POST_ADDRESSES_RESTORE_NG_SENDINGS_SUCCESS,
      }
    case POST_ADDRESSES_RESTORE_NG_SENDINGS_FAILURE:
      return {
        ...state,
        isPutting: false,
        prevItem: null,
        errorMessage: errMessages.ERR_RESTORE_NG_SENDINGS,
      }
    case POST_ADDRESSES_MOVE_NG_SENDINGS_REQUEST:
      return {
        ...state,
        isPutting: true,
      }
    case POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS:
      return {
        ...state,
        isPutting: false,
        shortMessage: action.payload.message !== "" ? action.payload.message : messages.POST_ADDRESSES_MOVE_NG_SENDINGS_SUCCESS,
        undoable: true,
        prevItem: action.payload.prevItem
      }
    case POST_ADDRESSES_MOVE_NG_SENDINGS_FAILURE:
      return {
        ...state,
        isPutting: false,
        errorMessage: action.payload.error.message !== "" ? action.payload.error.message : errMessages.ERR_REGIST_FAILURE,
      }
    case GET_EXECUTIVE_LIST_COUNT_SUCCESS:
      return {
        ...state,
        execListCount: action.payload.pageInfo ? action.payload.pageInfo.total: state.execListCount,
      }
    case PUT_ADDRESSES_TAGS_DELETEMULTI_REQUEST:
    case PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_REQUEST:
    case PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_REQUEST:
      return {
        ...state,
        isDeletingAddressTags: true,
      }
    case PUT_ADDRESSES_TAGS_DELETEMULTI_SUCCESS:
    case PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_SUCCESS:
    case PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_SUCCESS:
      return {
        ...state,
        isDeletingAddressTags: false,
        shortMessage: messages.DELETE_SUCCESS,
      }
    case PUT_ADDRESSES_TAGS_DELETEMULTI_FAILURE:
    case PUT_WARNING_ADDRESSES_TAGS_DELETEMULTI_FAILURE:
    case PUT_ERROR_ADDRESSES_TAGS_DELETEMULTI_FAILURE:
      return {
        ...state,
        isDeletingAddressTags: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_REMOVE_FAILURE),
      }
    case PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST:
    case PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST:
    case PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_REQUEST:
      return {
        ...state,
        isUpdatingAddressTags: true,
      }
    case PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS:
    case PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS:
    case PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_SUCCESS:
      return {
        ...state,
        isUpdatingAddressTags: false,
      }
    case PUT_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE:
    case PUT_WARNING_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE:
    case PUT_ERROR_ADDRESSES_TAGS_UPDATETAGNAMEMULTI_FAILURE:
      return {
        ...state,
        isUpdatingAddressTags: false,
        errorMessage: errMessages.ERR_EDIT_FAILURE
      }
    case POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_REQUEST:
      return {
        ...state,
        isVerifying: true,
      }
    case POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_SUCCESS:
      return {
        ...state,
        isVerifying: false,
        shortMessage: messages.VERIFY_SUCCESS
      }
    case POST_ADDRESS_CORPORATION_DIFFERENCES_VERIFY_FAILURE:
      return {
        ...state,
        isVerifying: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_VERIFY),
      }
    case GET_ADDRESS_CORPORATION_DIFFERENCES_COUNT_SUCCESS:
      return {
        ...state,
        addressCorporationDifferencesCount: action.payload.count,
      }
    case POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_REQUEST:
      return {
        ...state,
        isUpdatingDifferences: true,
      }
    case POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_SUCCESS:
      return {
        ...state,
        shortMessage: messages.UPDATE_SUCCESS,
        isUpdatingDifferences: false,
      }
    case POST_ADDRESS_CORPORATION_DIFFERENCES_UPDATE_DIFFERENCE_FAILURE:
      return {
        ...state,
        errorMessage: errMessages.ERR_UPDATE,
        isUpdatingDifferences: false,
      }
    case POST_WARNING_ADDRESSES_OVERWRITEMULTI_REQUEST:
    case POST_WARNING_ADDRESSES_MULTI_REQUEST:
      return {
        ...state,
        isOverwritingWarningAddresses: true,
        isSaving: true,
      }
    case POST_WARNING_ADDRESSES_OVERWRITEMULTI_SUCCESS:
    case POST_WARNING_ADDRESSES_MULTI_SUCCESS:
      if (action.payload.warnings.length === 0) {
        return {
          ...state,
          successMessage: `${action.payload.addresses.length}件のアイテムを登録しました。`,
          isOverwritingWarningAddresses: false,
          isSaving: false,
        }
      } else {
        return {
          ...state,
          isOverwritingWarningAddresses: false,
          isSaving: false,
          shortMessage: `${action.payload.addresses.length}件がリストに登録されました。${action.payload.warnings.length}件は、他にもエラーがあった為、警告ボックスに差し戻されました。`,
        }
      }
    case POST_WARNING_ADDRESSES_OVERWRITEMULTI_FAILURE:
    case POST_WARNING_ADDRESSES_MULTI_FAILURE:
      message = formatErrorMessage(action.payload.error)
      return {
        ...state,
        hasError: true,
        errorMessage: message ? message : formatErrorMessage(action.payload.error, errMessages.ERR_SAVE_FAILURE),
        isOverwritingWarningAddresses: false,
        isSaving: false,
      }
    case POST_ADDRESS_LIST_SALESFORCE_SYNC_REQUEST:
      return {
        ...state,
        isImporting: true,
      }
    case POST_ADDRESS_LIST_SALESFORCE_SYNC_SUCCESS:
      return {
        ...state,
        isImporting: false,
        message: action.payload.message,
        syncCount: action.payload.data ? action.payload.data.update_count : 0,
        lastUpdate: action.payload.data.instructed_at,
      }
    case POST_ADDRESS_LIST_SALESFORCE_SYNC_FAILURE:
      return {
        ...state,
        isImporting: false,
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_POST_SALESFORCE_SYNC_FAILURE
          ),
      };
    case STORE_FILTER_VALUE:
      return {
        ...state,
        filterValue: action.payload.filterValue
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/addressBook.js